<template>
  <v-container tag="section">
    <material-wizard
      :title="title"
      subtitle="Preencha as Informações para gerar seu cálculo."
      v-model="tab"
      :tabs="tabs"
      :available-steps="availableSteps"
      class="mx-auto"
      @click:next="next(true)"
      @click:prev="tab--"
      :loading="loading"
      :disabledBtnFinalizar="validTabs[tab + 1] === false"
      btnSaveCustomId="btn-save-saneamento-voc"
    >
      <saneamento-voc-wizard-tabs
        ref="parametrosSaneamentoVoc"
        :tab.sync="tab"
        :calculo="calculo"
        :cadernosServicosExistentes="cadernosServicosExistentes"
        :cmuExistentes="cmuExistentes"
        :normasTecnicasExistentes="normasTecnicasExistentes"
        :parametrosEspecificosRacCom="parametrosEspecificosRacCom"
        :bensDeInfraestrutura="bensDeInfraestrutura"
        @secondStepAvailable="validTabs[1] = $event"
        @thirdStepAvailable="validTabs[2] = $event"
        @fourthStepAvailable="validTabs[3] = $event"
        @btnFinishAvailable="validTabs[4] = $event"
      />
    </material-wizard>
  </v-container>
</template>

<script>
  import CmuService from "@/services/parametrosComCa/CmuService.js";
  import SaneamentoVocService from "@/services/SaneamentoVocService.js";
  import NormasTecnicasService from "@/services/parametrosComCa/NormasTecnicasService.js";
  import CadernosServicosService from "@/services/parametrosComCa/CadernosServicosService.js";
  import tourMixins from "@/mixins/tourMixins";

  export default {
    mixins: [tourMixins],

    components: {
      MaterialWizard: () => import("@/components/base/MaterialWizard.vue"),
      SaneamentoVocWizardTabs: () => import("@/components/saneamentoVoc/wizardTabs/SaneamentoVocWizardTabs.vue"),
    },

    mounted() {
      if (this.$route.params.id) {
        this.getCalculo(this.$route.params.id);
      }

      this.getCadernosServicos();
      this.getCmuExistentes();
      this.getNormasTecnicasExistentes();
      this.getParametrosEspecificosRacCom();
      this.iniciarPrimeiraTabTour();
    },

    data() {
      return {
        tab: 0,
        tabs: ["Início", "Flags", "Caderno de Serviços", "Racionalização do COM"],
        validTabs: { 0: true, 1: false, 2: false, 3: false, 4: undefined },
        availableSteps: [0],
        calculo: {},
        bensDeInfraestrutura: [],
        cadernosServicosExistentes: [],
        cmuExistentes: [],
        normasTecnicasExistentes: [],
        parametrosEspecificosRacCom: [],

        loading: false,
        arrPrimeiraTabTour: [
          {
            element: "#titulo-saneamento-voc",
            intro: "Aqui você deve inserir um nome para o seu Saneamento do VOC.",
            scrollTo: "tooltip",
            position: "right",
          },
          {
            element: "#obras-saneamento-voc",
            intro: "Aqui você poderá inserir códigos das obras que farão parte do cálculo.",
            scrollTo: "tooltip",
            position: "left",
          },
          {
            element: "#obras-nao-pertence-saneamento-voc",
            intro: "Caso for inserido códigos de obras, você poderá optar por utilizar o filtro não pertence",
            scrollTo: "tooltip",
            position: "left",
          },
          {
            element: "#tipologias-saneamento-voc",
            intro: "Aqui você poderá inserir códigos das tipologias que farão parte do cálculo.",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#tipologias-nao-pertence-saneamento-voc",
            intro: "Caso for inserido tipologias, você poderá optar por utilizar o filtro não pertence",
            scrollTo: "tooltip",
            position: "left",
          },
          {
            element: "#data-imobilizacao-saneamento-voc",
            intro: "Aqui você poderá filtrar, por data de imobilização, as obras que farão parte do cálculo.",
            scrollTo: "tooltip",
            position: "right",
          },
        ],
        arrSegundaTabTour: [
          {
            element: "#saneamento-voc-aplicar-flags",
            intro: "Aqui você poderá escolher se aplicará ou não Flags nas obras",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#saneamento-voc-parametrizacao-flags",
            intro:
              "Aqui você poderá escolher e configurar as aplicações de Flags no cálculo.<br>Obs.: Pelo menos uma flag deve ser aplicada.",
            scrollTo: "tooltip",
            position: "top",
          },
        ],
        arrTerceiraTabTour: [
          {
            element: "#saneamento-voc-aplicar-caderno-servicos",
            intro: "Aqui você poderá escolher se aplicará ou não Caderno de Serviços nas obras",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#saneamento-caderno-servicos",
            intro:
              "Aqui você deve definir o Caderno de Serviços utilizado no cálculo. É possivel escolher um já cadastrado no sistema ou fazer o upload em .CSV.",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#saneamento-voc-percentuais-padroes",
            intro: "Aqui você poderá definir os percentuais padrões de natureza de gastos.",
            scrollTo: "tooltip",
            position: "top",
          },
        ],
        arrQuartaTabTour: [
          {
            element: "#saneamento-voc-calculo-racionalizacao-com",
            intro:
              "Aqui você poderá escolher se habilitará ou não o cálculo de Racionalização do COM.<br>Obs.: pelo menos um cálculo deve ser habilitado.",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#saneamento-voc-cmu",
            intro:
              "Aqui você deve definir o CMU utilizado no cálculo. É possivel escolher um já cadastrado no sistema ou fazer o upload em .CSV.",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#saneamento-voc-normas-tecnicas",
            intro:
              "Aqui você deve definir as Normas Técnicas utilizadas no cálculo. É possivel escolher uma já cadastrada no sistema ou fazer o upload em .CSV.",
            scrollTo: "tooltip",
            position: "top",
          },
          {
            element: "#btn-save-saneamento-voc",
            intro: "Após seleção dos critérios anteriores clique aqui para salvar e executar o Saneamento do VOC.",
            scrollTo: "tooltip",
            position: "left",
          },
        ],
      };
    },

    computed: {
      title() {
        return this.$route.params.id ? `Editando Saneamento do VOC` : `Adicionando Novo Saneamento do VOC`;
      },
      userIdHexa() {
        return this.$store.getters.getUserIdHexa;
      },
      stepsProps() {
        return Object.values(this.validTabs).join("|");
      },
    },

    methods: {
      next(valid) {
        if (!valid) return;

        if (this.tab === this.tabs.length - 1) {
          this.salvar();
        } else {
          this.tab++;
        }
      },

      getCalculo(id) {
        SaneamentoVocService.getCalculo(id)
          .then((res) => {
            this.calculo = res.data.calculo;
            this.validTabs = { 0: true, 1: true, 2: true, 3: true, 4: undefined };
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar Saneamento do VOC", "", { position: "topRight" });
          });
      },

      getCadernosServicos() {
        CadernosServicosService.getCadernosServicos()
          .then((res) => {
            this.cadernosServicosExistentes = res.data.cadernos;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar Cadernos de Serviços cadastrados", "", { position: "topRight" });
          });
      },

      getCmuExistentes() {
        CmuService.getAllValoresUnitarios()
          .then((res) => {
            this.cmuExistentes = res.data.valores;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar CMUs cadastrados", "", { position: "topRight" });
          });
      },

      getNormasTecnicasExistentes() {
        NormasTecnicasService.getAllNormasTecnicas()
          .then((res) => {
            this.normasTecnicasExistentes = res.data.normas;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar Normas Técnicas cadastradas", "", { position: "topRight" });
          });
      },

      getParametrosEspecificosRacCom() {
        SaneamentoVocService.getParametrosEspecificosRacCom()
          .then((res) => {
            this.parametrosEspecificosRacCom = res.data.parametros.map((item) => ({
              descricao: item.Descricao,
              parametro: item.Parametro,
            }));
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao recuperar os parâmetros específicos da Rac. COM", "", { position: "topRight" });
          });
      },

      salvar() {
        const postData = this.$refs.parametrosSaneamentoVoc.exportData();
        const id = !this.$route.params.id ? null : this.$route.params.id;

        if (!postData.parametros.calculoDeCA && !postData.parametros.racionalizacaoDoCOM) {
          this.$toast.warning("Selecione pelo menos um tipo de calculo.", "", { position: "topRight" });
          return;
        }

        this.loading = true;

        SaneamentoVocService.salvar(id, this.userIdHexa, postData)
          .then((res) => {
            this.$router.push({ name: "Saneamento do VOC Historico" });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Erro ao salvar Saneamento do VOC", "", { position: "topRight" });
          })
          .finally(() => (this.loading = false));
        return;
      },

      iniciarPrimeiraTabTour() {
        this.doneLabel = "Proximo";
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: () => {
            this.$refs.parametrosSaneamentoVoc.secondTab.aplicarFlags = true;
            this.tab = 1;
            this.iniciarSegundaTabTour();
          },
        };

        this.iniciarTour(this.arrPrimeiraTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarSegundaTabTour() {
        this.doneLabel = "Proximo";
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: () => {
            this.$refs.parametrosSaneamentoVoc.thirdTab.aplicarCadernoServicos = true;
            this.tab = 2;
            this.iniciarTerceiraTabTour();
          },
        };

        this.iniciarTour(this.arrSegundaTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarTerceiraTabTour() {
        this.doneLabel = "Proximo";
        this.desativarTourAoSair = false;

        let onBeforeExitFunction = {
          func: () => {
            this.$refs.parametrosSaneamentoVoc.fourthTab.calculoRacionalizacaoDoCom = true;
            this.tab = 3;
            this.iniciarQuartaTabTour();
          },
        };

        this.iniciarTour(this.arrTerceiraTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarQuartaTabTour() {
        this.doneLabel = "Finalizar";
        this.desativarTourAoSair = true;

        let onBeforeExitFunction = {
          func: () => {
            this.$refs.parametrosSaneamentoVoc.thirdTab.aplicarCadernoServicos = false;
            this.$refs.parametrosSaneamentoVoc.fourthTab.calculoRacionalizacaoDoCom = false;
            this.tab = 0;
          },
        };

        this.iniciarTour(this.arrQuartaTabTour, [], [], [onBeforeExitFunction]);
      },
    },

    watch: {
      stepsProps() {
        const qtdSteps = this.tabs.length;

        for (let i = 1; i <= qtdSteps; i++) {
          this.validTabs[i] && this.validTabs[i - 1]
            ? this.availableSteps.push(i)
            : (this.availableSteps = this.availableSteps.filter((key) => key != i));
        }

        if (this.validTabs[qtdSteps - 1] && this.validTabs[qtdSteps] == undefined) this.availableSteps.push(qtdSteps);
      },
    },
  };
</script>
<style>
  .v-alert__icon {
    align-self: center;
  }
</style>
